import React from 'react';
import styles from "./index.less";

const Loading = () => (
    <div className={styles.spinnerMark}>
        <div className={styles.spinner}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
)

function Index(props: { isLoading: boolean, children?: JSX.Element }) {
    const {isLoading, children} = props;
    return (
        <>
            {isLoading ? <Loading/> : children}
        </>
    );
}

export default Index;